import React from 'react';

export default React.memo(function ButtonFulfilled({ className = '', children, ...props }) {
  return (
    <button {...props} className={`rounded-2xl inline-block py-5 bg-gradient select-none ${className}`}>
      {children}
    </button>
  )
})
